import { useRouter } from "next/router";

export const useOrderQueryClientQueryKeys = () => {
  const { query } = useRouter();

  const orderId = query?.id as string;

  const SINGLE_ORDER_QUERY_KEY = ["getSingleOrder", orderId];

  return {
    SINGLE_ORDER_QUERY_KEY,
  };
};
